import { Col, DatePicker, Input, Row } from 'antd';
import dayjs from 'dayjs';
import { t } from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';
import { DateIcon } from '../../../../asset';
import moment from 'moment';

const UserProfileCompletion = (props) => {
  const {grologAccInfo} = useSelector((state)=>state.auth)
 return (
    <>
      <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_USERNAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.username}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_TITLE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.title}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_FIRST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.first_name}
                disabled
              />
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_GENDER")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.gender}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_PHONE")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.phone}
                disabled
              />
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_LAST_NAME")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large'
                value={grologAccInfo?.last_name}
                disabled
              />
            </div>
          </Col>
        </Row>

        <hr className='border border-[#D9D9D9] my-10' />
        
        <div className='font-roboto font-semibold text-[20px] mt-5'>
          {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
        </div>
        <div className='font-roboto-medium text-[18px] font-medium mt-3'>
          {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
        </div>

        <Row className='mt-3'>
          <Col span={10}>
            <div>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_EMAIL")}
              </p>
              <Input 
                style={{ width: '100%' }} 
                size='large' 
                value={props?.form?.email}
                onChange={(value)=>props.handleChange(value,"email")}
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_EMAIL")} )}
                status={props?.error?.email ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.email}</div>
            </div>

            <div className='mt-3'>
              <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                {t("LOGIN_COMPLETION:LBL_BIRTH_DATE")}
              </p>
              <DatePicker 
              disabledDate={(current)=> {
                return current && current.isAfter(moment().format('YYYY-MM-DD'))
              }}
              format={"DD MMMM YYYY"}
              onChange={(e)=>props.handleChange(e, "birth_date")}
              value={dayjs(props?.form?.birth_date)}
              allowClear={false}
              suffixIcon={<img src={DateIcon} alt="date"/>}
                style={{ width: '100%' }} 
                size='large'
                placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_DATE")} )}
                status={props?.error?.birth_date ? "error" : ""}
                />
                <div className="text-red-100">{props?.error?.birth_date}</div>
            </div>
          </Col>
          <Col span={4}> </Col>
          <Col span={10}> </Col>
        </Row>
    </>
  );
};

export default UserProfileCompletion;